import styled from 'styled-components';

export const REWrapper = styled.div<{ hasError?: boolean }>`
	strong {
		font-weight: ${({ theme }) => theme.fonts.weights.bold};
	}

	.ql-tooltip {
		z-index: ${({ theme }) => theme.zIndex.tooltip};
	}

	.ql-header {
		width: 108px !important;
	}

	//Main container
	.ql-container {
		border: 1px solid ${({ theme }) => theme.colors.system.border.xStrong};
		border-radius: ${({ theme }) =>
			`0 0 ${theme.shapeRadius.small} ${theme.shapeRadius.small}`};
		background-color: ${({ theme }) => theme.colors.system.background.white};
	}

	//Toolbar
	.ql-toolbar {
		border: 1px solid ${({ theme }) => theme.colors.system.border.xStrong};
		border-radius: ${({ theme }) =>
			`${theme.shapeRadius.small} ${theme.shapeRadius.small} 0 0`};
		background-color: ${({ theme }) => theme.colors.system.background.system};

		.ql-picker-label {
			:hover {
				color: ${({ theme }) => theme.colors.primary.text.default};

				.ql-stroke {
					stroke: ${({ theme }) => theme.colors.primary.text.default};
				}

				.ql-fill {
					fill: ${({ theme }) => theme.colors.primary.text.default};
				}
			}
		}

		.ql-picker-item {
			&:hover {
				color: ${({ theme }) => theme.colors.primary.text.default};
			}

			&.ql-selected {
				color: ${({ theme }) => theme.colors.primary.text.default};
			}
		}

		.ql-formats {
			margin-right: 9px !important;

			&.insert-merge-tags {
				button {
					font-size: ${({ theme }) => theme.fonts.sizes.medium};
				}
			}

			button {
				:hover {
					color: ${({ theme }) => theme.colors.primary.text.default};

					.ql-stroke {
						stroke: ${({ theme }) => theme.colors.primary.text.default};
					}

					.ql-fill {
						fill: ${({ theme }) => theme.colors.primary.text.default};
					}
				}
			}
		}
	}

	//Editor
	.ql-editor {
		border: 1px solid transparent;
		border-radius: ${({ theme }) =>
			`0 0 ${theme.shapeRadius.small} ${theme.shapeRadius.small}`};

		&:focus,
		&:active {
			box-shadow: ${({ theme, hasError }) =>
				!hasError && theme.shadows.controls.selected};
			border: 1px solid
				${({ theme, hasError }) =>
					hasError ? 'initial' : theme.colors.primary.border.default};
			outline: none;
		}

		// Placeholder
		&.ql-blank {
			&::before {
				color: ${({ theme }) => theme.colors.system.text.weak};
				font-style: normal;
				font-size: ${({ theme }) => theme.fonts.sizes.small};
			}
		}
	}
`;
